import { GraphQLError } from 'graphql/error/GraphQLError'
import { HandlerType } from '@/handler/index'
import { ErrorInfo } from '@/store/types'

export class GraphQLException extends Error {
  public constructor(readonly errors: ReadonlyArray<GraphQLError>) {
    super()
    this.errors = errors
  }
}

export class ErrorBag {
  private errors = new Map()

  public add(code: string, message: string): ErrorBag {
    this.errors.set(code, message)
    return this
  }

  public all(): Array<ErrorInfo> {
    const errorInfo: Array<ErrorInfo> = []
    this.errors.forEach((message, code) => {
      errorInfo.push({
        code,
        message,
      })
    })
    return errorInfo
  }
}

const GraphQLExceptionHandler: HandlerType = (err: Error) => {
  const result: ErrorBag = new ErrorBag()
  if (err instanceof GraphQLException) {
    err.errors.forEach((e) => {
      if (e.extensions?.category === 'validation') {
        Object.entries(e.extensions?.validation).forEach(([f, messages]) => {
          const messageArray = messages as Array<string>
          messageArray.forEach((m) => {
            result.add(f, m)
          })
        })
      } else {
        result.add(e.extensions?.code, e.extensions?.message)
      }
    })
  }
  return result
}

export default GraphQLExceptionHandler
